<!-- ===================== HERO / ANATOMÍA DE LA ETIQUETA ===================== -->
<section class="anatomy" id="etiqueta">
  <div class="anatomy-head">
    <span class="eyebrow">{{ 'etiqueta.eyebrow' | translate }}</span>
    <h1 class="anatomy-title">{{ typed }}</h1>
    <p class="section-lead center" [innerHTML]="'etiqueta.leadHtml' | translate"></p>
  </div>
  <div class="anatomy-grid">
    <div class="anatomy-col left">
      <div class="callout" [innerHTML]="'etiqueta.calloutLeft1Html' | translate"></div>
      <div class="callout" [innerHTML]="'etiqueta.calloutLeft2Html' | translate"></div>
    </div>
    <div class="anatomy-center">
      <img class="label-3d"
           [src]="labels[labelIndex]"
           [class.scale-out]="labelClass === 'scale-out'"
           [class.scale-in]="labelClass === 'scale-in'"
           [style.transform]="centerTransform"
           [alt]="'etiqueta.centerImgAlt' | translate"
           (mousemove)="onLabelMove($event)"
           (mouseout)="onLabelOut()"
           (mousedown)="onLabelDown()"
           (mouseup)="onLabelUp()">
      <div class="callout" [innerHTML]="'etiqueta.calloutCenterHtml' | translate"></div>
    </div>
    <div class="anatomy-col right">
      <div class="callout" [innerHTML]="'etiqueta.calloutRight1Html' | translate"></div>
      <div class="callout" [innerHTML]="'etiqueta.calloutRight2Html' | translate"></div>
    </div>
  </div>
</section>

<!-- ===================== TIPOS DE PRODUCTO (4 tarjetas) ===================== -->
<section class="types">
  <span class="eyebrow">{{ 'etiqueta.typesEyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'etiqueta.typesTitleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'etiqueta.typesLead' | translate }}</p>
  <div class="type-grid" #cards>
    <div class="type-card" *ngFor="let i of cardIndexes">
      <div class="tile"><img [src]="cardIcons[i]" alt=""></div>
      <h3>{{ 'etiqueta.cards.' + i + '.title' | translate }}</h3>
      <p [innerHTML]="'etiqueta.cards.' + i + '.textHtml' | translate"></p>
    </div>
  </div>
</section>

<!-- ===================== CARACTERÍSTICAS DE LA ETIQUETA ===================== -->
<section class="app-section">
  <div class="app-head">
    <span class="eyebrow">{{ 'etiqueta.qualEyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'etiqueta.qualTitleHtml' | translate"></h2>
  </div>
  <div class="feature-block">
    <div class="fb-media plain">
      <img [src]="labelsText[textIndex]"
           [class.scale-out]="textClass === 'scale-out'"
           [class.scale-in]="textClass === 'scale-in'"
           [alt]="'etiqueta.labelTextImgAlt' | translate">
    </div>
    <div class="fb-text">
      <div class="qualities">
        <div class="quality" *ngFor="let i of qualityIndexes">
          <span class="check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>
          <p [innerHTML]="'etiqueta.qualities.' + i | translate"></p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===================== INTEGRACIÓN ===================== -->
<section class="app-section alt">
  <div class="app-head">
    <span class="eyebrow">{{ 'etiqueta.intEyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'etiqueta.intTitleHtml' | translate"></h2>
  </div>
  <div class="feature-block reverse">
    <div class="fb-text">
      <p [innerHTML]="'etiqueta.intP1Html' | translate"></p>
      <p [innerHTML]="'etiqueta.intP2Html' | translate"></p>
    </div>
    <div class="fb-media plain">
      <img class="api" [src]="apiImg" alt="API" onerror="this.style.display='none'">
    </div>
  </div>
</section>
